<template>
    <div>
        <div class="row mx-auto">
        <span class="d-flex align-items-center">
            +
        </span>
            <span
                v-if="fixCountryCode"
                class="d-flex align-items-center mr-1"
            >
            {{ fixCountryCode }}
        </span>
            <input
                v-else
                id="checkout_phone_number"
                v-model="currentCountryCode"
                type="text"
                autocomplete="phone_number_country_code"
                class="form-control col-3 col-md-1"
                :class="{ 'is-invalid': errors && (errors['phone_number.country_code'] || errors['phoneNumber.countryCode']) }"
            >
            <input
                v-model="currentPrefix"
                type="text"
                autocomplete="phone_number_prefix"
                class="form-control col-3 col-md-1"
                :class="{ 'is-invalid': errors && (errors['phone_number.prefix'] || errors['phoneNumber.prefix']) }"
            >
            <input
                v-model="currentLineNumber"
                type="text"
                autocomplete="phone_number_line_number"
                class="form-control col-4 col-md-2"
                :class="{ 'is-invalid': errors && (errors['phone_number.line_number'] || errors['phoneNumber.lineNumber']) }"
            >
        </div>
        <MultiFormError
            :fields="errorFields"
            :errors="errors"
        />
    </div>
</template>

<script>
import MultiFormError from '../../../MultiFormError'

export default {
    name: 'PhoneNumberField',

    components: { MultiFormError },

    props: {
        fixCountryCode: {
            type: String,
            default: null
        },

        countryCode: {
            type: String,
            default: ''
        },

        prefix: {
            type: String,
            default: null
        },

        lineNumber: {
            type: String,
            default: null
        },
        errors: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            currentCountryCode: this.fixCountryCode ? this.fixCountryCode : this.countryCode,
            currentPrefix: this.prefix,
            currentLineNumber: this.lineNumber,
        }
    },

    computed: {
        errorFields() {
            return [
                'phone_number',
                'phone_number.country_code',
                'phone_number.prefix',
                'phone_number.line_number',
                'phoneNumber',
                'phoneNumber.countryCode',
                'phoneNumber.prefix',
                'phoneNumber.lineNumber',
            ]
        }
    },

    watch: {
        currentCountryCode() { this.emitNewValue() },
        currentPrefix() { this.emitNewValue() },
        currentLineNumber() { this.emitNewValue() },
    },

    methods: {
        emitNewValue() {
            this.$emit('input', {
                countryCode: this.currentCountryCode,
                prefix: this.currentPrefix,
                lineNumber: this.currentLineNumber
            })
        }
    }
}
</script>
